import {
  chakra,
  forwardRef,
  type TableColumnHeaderProps,
} from '@chakra-ui/react-v2';
import { cx } from '@chakra-ui/utils';
import { useMemo } from 'react';

import { useTableStyles } from '../TableStylesContext';
import { useTableContext } from '../utils/context';
import { getClassName } from './className';

const RELAXED_PADDING_BY_SIZE: Record<string, number> = {
  sm: 1.75,
  md: 2.25,
};

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ThProps extends TableColumnHeaderProps {}

export const Th = forwardRef<ThProps, 'th'>(({ className, ...props }, ref) => {
  const { th: thStyles } = useTableStyles() ?? {};

  const { density, size } = useTableContext() ?? {};

  const thCss = useMemo(
    () => ({
      ...thStyles,
      ...(density === 'relaxed'
        ? {
            _first: {
              pl: RELAXED_PADDING_BY_SIZE[size],
            },
            _last: {
              pr: RELAXED_PADDING_BY_SIZE[size],
            },
          }
        : null),
    }),
    [size, density, thStyles],
  );

  return (
    <chakra.th
      ref={ref}
      __css={thCss}
      className={cx(getClassName('th'), className)}
      {...props}
    />
  );
});
